<template>
  <NavigationLayout :padding="true">
    <SplitLayout
      :route-param="routeParam"
      :query-param-map="queryParamMap"
      :route-component="components.routeComponent">
      <Table
        :config="config"
        :data="providers"
        @row-selected="rowSelected">
        <template slot="controls">
          <vk-icon-button
            :href="createNewObjectLink"
            ratio="0.85"
            icon="plus"
          />
        </template>
      </Table>
    </SplitLayout>
  </NavigationLayout>
</template>

<script>
  import NavigationLayout from '../../components/layout/NavigationLayout'
  import SplitLayout from '../../components/layout/SplitLayout'
  import SplitViewMixin from '../../mixins/split-view'
  import Provider from '../../views/web/Provider'
  import Table from '../../components/global/Table'
  import {mapGetters} from 'vuex'
  import Domain from '../../views/web/Domain'
  import Server from '../../views/web/Server'
  import Page from '../../views/web/Page'

  export default {
    computed: {
      ...mapGetters({
        providers: 'web/providers'
      })
    },
    data() {
      return {
        config: null,
      }
    },
    created() {
      this.setup('providers', 'providerId', Provider, {
        serverId: Server,
        domainId: Domain,
        pageId: Page,
      })
      this.config = this.createTableConfig('nav.providers', 'web.no_providers_found')
      this.loading = true
      this.$store.dispatch('web/loadProviders', {
        appId: this.$route.params.appId
      }).finally(() => this.loading = false)
    },
    mixins: [
      SplitViewMixin
    ],
    components: {
      Table,
      SplitLayout,
      NavigationLayout
    }
  }
</script>